import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  #root {
    overflow: hidden;
  }
  
  body {
    margin: 0;
    font-family: ${({ theme }) => theme.font.fontFamily};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'kern';
    scroll-behavior: smooth;
    font-variant: proportional-nums;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    color: ${({ theme }) => theme.colors.primaryColor};
  }
  
  h1 {
  font-size: 50px;
  letter-spacing: -0.05em;
  font-weight: 900;
  margin: 0;
  }

  h2 {
    font-size: 2rem;
    letter-spacing: -1px;
    margin-bottom: 1rem;
    line-height: 1.3;
    font-weight: 700;
  }

  h3 {
    font-weight: 700;
    font-size: 1.8rem;
    letter-spacing: -1px;
    margin: 0;
  }

  h4 {
    font-weight: 600;
    font-size: 1.2rem;
    letter-spacing: -1px;
  }

  button{
    cursor: pointer;
    transition: all 0.3s;
  }

  tspan {
    pointer-events: none;
    font-family: ${({ theme }) => theme.font.fontFamily};
  }

  #dims tspan {
    font-family: ${({ theme }) => theme.font.dimsFontFamily};
  }

  .spinner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.5;
    z-index: 1000;
    display: block;
    width: 100%;
    height: 100%;
    .ant-spin-dot {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -10px;
    }
  }

  .hidden {
    display: none;
  }

  .sp-inv-item {
    cursor: pointer;
  }

  .pe-none {
    pointer-events: none;
  }

  .divider {
    width: 70%;
    margin: auto;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }

  .vertical-divider {
    margin: 10px 0;
    border-left: 1px solid rgba(0, 0, 0, 0.06);
  }

  .ant-modal-title {
    text-transform: capitalize;
    text-align: center;
  }

  .pe-none {
    pointer-events: none;
  }

  /************* PRINT **************/
  .print-modal > .ant-modal-content > .ant-modal-body {
    background-color: #5d6553 !important;
  }

  .print-modal > .ant-modal-content > .ant-modal-close {
    color: #fff;
  }

  @media (max-width: 567px), (max-height: 567px) {
    h3 {
      font-size: 1.5rem;
    }
    h4 {
      font-size: 1rem;
    }
  }`;

export default GlobalStyle;
